import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { filter, Observable, take, tap } from "rxjs";
import { UserDetails } from "../../domain/user";
import { NavigationService } from "../../services/navigation.service";
import { UserService } from "../../services/user.service";
import { reportToSentry } from "../sentry/reportFunctions";

function handleUserNotFound(navigationService: NavigationService): void {
  reportToSentry("Did not find 'self' user from API for logged-in user", "User.Other");
  navigationService.navigateToSignIn();
}

export const userResolver: ResolveFn<UserDetails> = (): Observable<UserDetails> => {
  const userService = inject(UserService);
  const navigationService = inject(NavigationService);

  return userService.getSelf$().pipe(
    tap((user) => user === null && handleUserNotFound(navigationService)),
    filter((user): user is UserDetails => user !== null),
    take(1),
  );
};
